var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOurmissiondeco3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 361,
    height: 203,
    viewBox: "0 0 361 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.226 0C359.226 0 378.197 112.074 194.3 121.082C10.4035 130.09 0 203 0 203L0 0H359.226Z",
    fill: "#FDA2FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30.5,
    r: 30.5,
    transform: "matrix(-1 0 0 1 181 98)",
    fill: "#F8D5B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurmissiondeco3);
export default __webpack_public_path__ + "static/media/ourmissiondeco-3.2ec8f58cb111f60de275d6c795061a21.svg";
export { ForwardRef as ReactComponent };